
import { Hotkey } from '@ngneat/hotkeys';
export const SettingsKey = 's';
export const HOTKEYS_AVOID_HIDE_CONTROLS = [SettingsKey, 'c', 'd', 'r'];

export declare type VgHotkey = Hotkey & {
	handler?: any
};

export function formatHotkeyHelp(text: string, key: string) {
	return `${text} (${key})`;
}
